import { Component, HostListener } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import { LanguageService } from './../../Services/languageService';
import { TranslateService } from '@ngx-translate/core';
import * as $ from 'jquery';
//declare let $: any;
@Component({
  selector: 'BeforeLogin',
  templateUrl: './BeforeLogin.html',
  styleUrls: ['./BeforeLogin.css']
})
export class BeforeLogin {
   public License:boolean;
   public OTP:boolean;
   public Vehicle:boolean;
   public Count:number=1;
   public Motor:boolean;
   public SelectedType:string;
   public lng:string;
   public isEnglish:boolean= true;
   public Language: string = 'en';
   public showSubscriptionDropdown: boolean = false;
   public showDropdown: boolean = false;

   
constructor(private router: Router,private lngService:LanguageService,private translate:TranslateService){
  // sessionStorage.setItem("Language","ar")
  // if(sessionStorage.getItem("Language")!=null){
  //   $("body").removeClass("Arabic");
  //   this.translate.setDefaultLang(sessionStorage.getItem("Language"));
  //   if(sessionStorage.getItem("Language")=='en'){
  //    this.translate.currentLang="en";
  //    $("body").removeClass("Arabic");
  //    this.isEnglish=true;
  //   }
  //   else if(sessionStorage.getItem("Language")=='ar'){
  //       this.translate.currentLang="ar";
  //        $("body").addClass("Arabic");
  //      this.isEnglish=false; 
  //   }
  //  }
  //  else{
  //    this.translate.setDefaultLang('en');
  //    this.translate.currentLang="en";
  //    sessionStorage.setItem("Language","en")
  //    $("body").removeClass("Arabic");
  //    this.isEnglish=true;
    
  //  }
 

   // Set default language
   const storedLang = sessionStorage.getItem("Language");

   if (storedLang === 'ar') {
     this.Language = 'ar';
     this.isEnglish = false;
     $("body").addClass("Arabic");
     this.translate.setDefaultLang('ar');
     this.translate.currentLang="ar";
     this.translate.use('ar');
   } else {
     this.Language = 'en';
     this.isEnglish = true;
     $("body").removeClass("Arabic");
     this.translate.setDefaultLang('en');
     this.translate.currentLang="en";
     this.translate.use('en');
   }

   const body = document.getElementById("body");
   if (body) {
     body.dir = this.Language === "ar" ? "rtl" : "ltr";
   }
 
}

@HostListener('document:click', ['$event'])
  handleClickOutside(event: Event) {
    const target = event.target as HTMLElement;

    if (!target.closest('.subscription-wrapper')) {
      this.showSubscriptionDropdown = false;
    }
  }
  
  toggleSubscriptionDropdown() {
    this.showSubscriptionDropdown = !this.showSubscriptionDropdown;
  }

// changeLanguage(langauge) {
//   if(langauge=="en"){
//     this.isEnglish=true;
//     sessionStorage.setItem("Language","en");
//     $("body").removeClass("Arabic");
//   }
//   else if(langauge=="ar"){
//     this.isEnglish=false;
//     $("body").addClass("Arabic");
//     sessionStorage.setItem("Language","ar");
//   }
//   //sessionStorage.setItem("Language",langauge)

//   this.translate.use(langauge);
//   this.lngService.setLng(langauge)
// }

changeLanguage(language: string) {
  const body = document.getElementById("body");

  if (body) {
    if (language === 'ar') {
      body.dir = 'rtl';
      this.translate.use('ar');
      $("body").addClass("Arabic");
    } else {
      language = 'en';
      body.dir = 'ltr';
      this.translate.use('en');
      $("body").removeClass("Arabic");
    }
  }
  sessionStorage.setItem("Language", language);
  this.Language = language;
  this.isEnglish = language === 'en';
  this.lngService.setLng(language);  // Optional if you're using shared LanguageService
  this.reloadComponent();
}

  toggleDropdown(event: MouseEvent): void {
    event.stopPropagation();  // Prevent dropdown from closing instantly
    this.showDropdown = !this.showDropdown;
  }

  closeDropdownOutside(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.dropdown')) {
      this.showDropdown = false;
    }
  }

  goToUnsubscribe() {
    this.router.navigate(['/BeforeLogin', 'Unsubscribe']);
  }

  reloadComponent() {
    const currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }
 
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/BeforeLogin/BeforeLogin.ts